interface Idle {
  kind: 'idle';
}

interface Cloning {
  kind: 'cloning';
  collectionName: string;
}

interface Cloned {
  kind: 'cloned';
  newCollectionId: number;
  collectionName: string;
  // Courses could not be copied or were left out: the dialog asks the admin
  // to review the collection's courses before publishing.
  coursesNeedReview: boolean;
}

interface CloneFailed {
  kind: 'clone-failed';
}

export type State = Idle | Cloning | Cloned | CloneFailed;

export const idle = (): Idle => ({ kind: 'idle' });

export const cloning = (collectionName: string): Cloning => ({ kind: 'cloning', collectionName });

export const cloned = (
  newCollectionId: number,
  collectionName: string,
  coursesNeedReview: boolean,
): Cloned => ({
  kind: 'cloned',
  newCollectionId,
  collectionName,
  coursesNeedReview,
});

export const cloneFailed = (): CloneFailed => ({ kind: 'clone-failed' });
